import { createAction, handleActions } from 'redux-actions';

const setInitializing = createAction("MODALS/EMAIL_PROJECT_INFORMATION/SET_INITIALIZING");

const defaultState = false;

const reducer = handleActions(
  {
    [setInitializing]: (state, action) => action.payload
  },
  defaultState
);

export { setInitializing, reducer };